import { combineReducers } from "redux";
import { routerReducer as routing } from "react-router-redux";

import app from "modules/app/index";
import auth from "modules/auth/index";
import affiliate from "modules/affiliate/index";
import calendar from "modules/calendar/index";
import accommodation from "modules/accommodation/index";
import customers from "modules/customers/index";
import dashboard from "modules/dashboard/index";
import orders from "modules/orders/index";
import products from "modules/products/index";
import agents from "modules/agents/index";
import finances from "modules/finances/index";
import reviews from "modules/reviews/index";
import settings from "modules/settings/index";

export default combineReducers({
  routing,
  app: app.reducer,
  auth: auth.reducer,
  affiliate: affiliate.reducer,
  calendar: calendar.reducer,
  accommodation: accommodation.reducer,
  customers: customers.reducer,
  dashboard: dashboard.reducer,
  orders: orders.reducer,
  products: products.reducer,
  agents: agents.reducer,
  finances: finances.reducer,
  reviews: reviews.reducer,
  settings: settings.reducer,
});



// WEBPACK FOOTER //
// ./src/app/RootReducer.js